import styled from '@emotion/styled';
import { JockeyAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails';
import { withConfig } from 'src/withConfig';

export const SelectionList = withConfig(theme => styled('ul', { label: 'SelectionList' })`
    border: 1px solid ${theme.star.raceSummary.borderColor};
`);

export const SilkCellRaceSummaryWrapper = styled('div', { label: 'SilkCellRaceSummaryWrapper' })`
    align-items: center;
    display: flex;
    flex: 0 0 36px;
    justify-content: center;
`;

export const CellRunner = styled('div', { label: 'CellRunner' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 8px;
    justify-content: start;
    min-width: 120px;
    overflow: hidden;
    padding: 8px 12px;
`;

export const JockeyAndTrainerDetailsBox = withConfig(theme => styled(JockeyAndTrainerDetails, { label: 'JockeyAndTrainerDetailsBox' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    width: 100%;
`);

export const RaceSummary = withConfig(theme => styled('div', { label: 'RaceSummary' })`
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3;
    margin-top: -1px;
    &:first-of-type {
        margin-top: -1px;
    }
`);

export const NonRunnerCellMatchBet = withConfig(theme => styled('span', { label: 'NonRunnerCellMatchBet' })`
    align-items: center;
    border-left: 1px solid ${theme.star.raceSummary.borderColor};
    border-right: 1px solid ${theme.star.raceSummary.borderColor};
    display: flex;
    flex: 0 0 48px;
    font-size: ${theme.star.fontSize.small};
    justify-content: center;
    margin-left: -1px;
    width: 48px;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 64px;
        width: 64px;
        font-size: ${theme.star.fontSize.xRegular};
    }
`);
